if (!customElements.get('header-drawer')) {
  class HeaderDrawer extends HTMLElement {
    constructor() {
      super();
      this.details = this.querySelector('details');
      this.summary = this.querySelector('summary');
      this.closeButtons = this.querySelectorAll('.menu-drawer__close-button, .menu-drawer__close-menu-btn');
      this.bindEvents();
    }

    bindEvents() {
      this.summary.addEventListener('click', (event) => {
        event.preventDefault();
        this.open();
      });

      this.closeButtons.forEach(button => {
        button.addEventListener('click', (event) => {
          event.preventDefault();
          this.close();
        });
      });

      document.addEventListener('keyup', (event) => {
        if (event.key === 'Escape') {
          this.close();
        }
      });
    }

    open() {
      this.details.setAttribute('open', '');
      document.body.classList.add('overflow-hidden');
      this.setAttribute('open', '');
    }

    close() {
      this.details.removeAttribute('open');
      document.body.classList.remove('overflow-hidden');
      this.removeAttribute('open');
    }
  }

  customElements.define('header-drawer', HeaderDrawer);
}
